import api from './api';

export const getAvailableSlots = async (cp, leadid, date = null) => {
  const params = { cp };
  if (leadid) params.leadid = leadid;
  if (date) params.date = date;
  const response = await api.get('/slots', { params });
  return response.data;
};

export const bookAppointment = async (data) => {
  const response = await api.post('/book', data);
  return response.data;
};

export const getTeams = async () => {
  const response = await api.get('/teams');
  return response.data;
};
